export default "__VITE_ASSET__Cqw$697E__"